import React, { useContext } from "react";
import ReactECharts from "echarts-for-react";
import { DisplayAmount } from "../../../../../../display-amount-context";
import { AlertContainer, Card } from "./Styled";
import Button from "../../../../../../ui/button";
import { numberToCurrency } from "../../../../../../utils/formatters";

type Props = {
  investments: any[];
};

const CHART_COLORS = [
  "#1F4CA0",
  "#3470C0",
  "#4B95DF",
  "#62B8FE",
  "#8BCBFE",
  "#B5DDFF",
  "#003366",
  "#004D99",
  "#0066CC",
  "#4394E5",
];

const WalletCard: React.FC<Props> = ({ investments }) => {
  const {
    state: { displayAmount },
  } = useContext(DisplayAmount);

  const paidInvestments = investments.filter(
    (investment) => investment.status === "paid"
  );

  const groupedInvestments = Object.values(
    paidInvestments.reduce((acc, investment) => {
      const { code } = investment.opportunity;

      if (!acc[code]) {
        acc[code] = {
          opportunity_code: code,
          investable_type: investment.investable_type,
          amount_value: 0,
        };
      }
      acc[code].amount_value += investment.amount_value;

      return acc;
    }, {})
  );

  const totalAmount = groupedInvestments.reduce(
    (sum, { amount_value }) => sum + amount_value,
    0
  ) as number;

  const data = groupedInvestments.map(
    ({ opportunity_code, investable_type, amount_value }) => ({
      name: `${investable_type
        .slice(0, 2)
        .toUpperCase()} #${opportunity_code}:\n${
        displayAmount ? numberToCurrency(amount_value) : "••••"
      }`,
      value: amount_value,
    })
  );

  const options = {
    color: CHART_COLORS,
    tooltip: {
      trigger: "item",
      formatter: ({ name, value, percent }) => {
        return `${name} (${percent}%)`;
      },
    },
    legend: {
      right: 0,
      top: "center",
      type: "scroll",
      orient: "vertical",
      pageIconColor: "#1D297C",
      icon: "circle",
    },
    graphic: {
      elements: [
        {
          type: "text",
          left: "center",
          top: "middle",
          z: 999,
          style: {
            text: displayAmount ? numberToCurrency(totalAmount) : "••••",
            textAlign: "center",
          },
        },
      ],
    },
    series: [
      {
        type: "pie",
        radius: ["60%", "90%"],
        label: false,
        data,
      },
    ],
  };

  return (
    <Card>
      <h1>Carteira Mercatório</h1>

      {groupedInvestments.length > 0 ? (
        <ReactECharts option={options} style={{ height: 200 }} />
      ) : (
        <AlertContainer>
          <span>Você ainda não possui investimentos com a gente.</span>
          <Button href="/investir" variant="primary" size="sm" rounded>
            Investir
          </Button>
        </AlertContainer>
      )}
    </Card>
  );
};

export default WalletCard;
